import { render, staticRenderFns } from "./index.vue?vue&type=template&id=206812bb&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206812bb",
  null
  
)

export default component.exports